import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdvanceType, DocumentType, ModalDialogType } from 'src/app/@core/constants';
import { PaymentComplianceAlertModalService } from 'src/app/@core/services/payment-compliance-alert-modal.service';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { PosPrintDocumentsModalService } from 'src/app/@core/services/pos-print-documents-modal.service';
import { CalculationUtils } from 'src/app/@core/utils/calculation-utils';
import { Customer } from 'src/app/models/customer';
import { Payment } from 'src/app/models/payment';
import { AdvanceCreateRequest } from 'src/app/models/request/advance-create-request';
import { AdvanceService } from 'src/app/services/advance.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CustomerService } from 'src/app/services/customer.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-advance-create',
  templateUrl: './advance-create.component.html',
  styleUrls: ['./advance-create.component.sass']
})
export class AdvanceCreateComponent implements OnInit {

  customer: Customer = new Customer();
  advanceForm: FormGroup = new FormGroup({
    amount: new FormControl(null, [Validators.required, Validators.min(1)]),
    observations: new FormControl(undefined, [Validators.required])
  })
  constructor(private route: ActivatedRoute, private customerService: CustomerService, private configService: ConfigurationService, private datePipe: DatePipe, private confirmService: PosConfirmationService, private advanceService: AdvanceService, private router: Router, private toastr: ToastrService, private readonly printModalService: PosPrintDocumentsModalService, private readonly exceptionSolutionService: ExceptionSolutionService, private readonly paymentComplianceModalService: PaymentComplianceAlertModalService) { }

  async ngOnInit(): Promise<void> {

    this.customer = await this.customerService.readCustomerByCode(this.route.snapshot.params.id).toPromise();
  }

  async doPayment(paymentData: {
    payments: Array<Payment>;
    paymentsAmount: number;
    id: string;
  }) {
    if (paymentData.payments.length <= 0) {
      return;
    }
    if (Number(paymentData.paymentsAmount) < this.getTotal()) {
      this.exceptionSolutionService.showAlertWithSolution(`Anticipos`, `No coinciden el anticipo ${this.getTotal()} con el total de los pagos ${paymentData.paymentsAmount}`, undefined, 'error');
      return;
    }
    if (await this.paymentComplianceModalService.validatePaymentCompliance(null, this.customer.code, this.configService.readSelectedBranchAndSalesOrg().branch.code, this.configService.readSelectedBranchAndSalesOrg().salesOrg.code, "contado", paymentData.payments)) {
      return;
    }
    await this.confirmService.show("Creación de Anticipo", `¿Esta seguro de querer crear este anticipo para el cliente ${this.customer.code} con el monto ${this.getTotal()}?`, ModalDialogType.SUCCESS, async () => {
      const request = new AdvanceCreateRequest();
      request.paymentsRequestModel.branchCode = this.configService.readSelectedBranchAndSalesOrg().branch.code;
      request.paymentsRequestModel.createdOn = this.datePipe.transform(new Date(), "YYYYMMdd") || "";
      request.paymentsRequestModel.documentType = "ADVANCE";
      request.paymentsRequestModel.payments = paymentData.payments.map(m => {
        m.documentType = DocumentType.ADVANCE;
        return m;
      });
      request.paymentsRequestModel.registerCode = this.configService.readRegister().code;
      request.paymentsRequestModel.salesOrgCode = this.configService.readSelectedBranchAndSalesOrg().salesOrg.code;
      request.customerCode = this.customer.code;
      request.advanceType = AdvanceType.SHOP;
      request.observations = this.advanceForm.value.observations;
      request.origin = "POS";
      const result = await this.advanceService.createAdvance(request).toPromise();
      Swal.fire({
        title: `Anticipo`,
        html: `Se ha generado el anticipo con código ${result.response.receiptCode}`,
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });

      await this.printModalService.showPrintAdvanceDocuments(result.response);
      this.router.navigate(["customer", "advances", this.customer.code]);
    })

  }

  getTotal() {
    return CalculationUtils.round(this.advanceForm.value.amount ?? 0);
  }


}
